import { render, staticRenderFns } from "./EditCommercialPropertySectionModal.vue?vue&type=template&id=1cdb8a79&"
import script from "./EditCommercialPropertySectionModal.vue?vue&type=script&lang=js&"
export * from "./EditCommercialPropertySectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports